// Données SEO uniques pour chaque commune — contenu spécifique (géologie, PLU, mairie)
// Utilisé par /app/frontend/src/pages/CommunePage.jsx

export const COMMUNES = {
  "saint-denis": {
    slug: "saint-denis",
    name: "Saint-Denis",
    region: "Nord",
    tagline: "Chef-lieu de La Réunion",
    intro:
      "Construire à Saint-Denis, chef-lieu et préfecture de La Réunion, implique de composer avec un tissu urbain extrêmement dense, des règles d'urbanisme strictes et des contraintes patrimoniales fortes en cœur de ville. Solmis Habitat accompagne les particuliers et les professionnels sur les projets de construction neuve, d'extension et de surélévation dans toutes les zones de la commune : centre-ville, La Source, La Bretagne, Sainte-Clotilde, Le Chaudron, jusqu'aux hauts du Brûlé et de La Montagne. Notre maîtrise du PLU de Saint-Denis, des servitudes d'urbanisme et du dialogue avec le service instructeur de la mairie nous permet d'obtenir des dossiers de permis de construire conformes et acceptés sans aller-retour inutile.",
    geology:
      "Le territoire dionysien combine plusieurs profils géologiques : sols alluvionnaires en bord de mer et le long de la rivière Saint-Denis, basaltes massifs sur la pente urbaine intermédiaire, et terrains volcaniques hétérogènes avec scories sur les hauts (La Montagne, Le Brûlé). Une étude de sol G2 est quasi systématique en construction neuve, surtout sur les terrains en pente, à proximité des ravines, ou dans les secteurs concernés par le PPRI de la rivière des Pluies.",
    plu:
      "Le PLU de Saint-Denis (révision opposable depuis 2019) distingue plusieurs zones U urbaines très réglementées avec prescriptions architecturales fortes en centre-ville (périmètre des Architectes des Bâtiments de France pour les abords des monuments historiques), des zones AU à urbaniser, et des zones N et A protégées dans les hauts. Hauteurs maximales, emprise au sol, recul par rapport aux limites séparatives et coefficient de végétalisation varient selon le zonage de votre parcelle.",
    mairie:
      "Mairie de Saint-Denis — Service Urbanisme, 2 rue de Paris, 97400 Saint-Denis. Délai d'instruction effectif observé : conforme au délai légal (2 mois pour une maison individuelle, 3 mois pour les autres projets).",
    secteurs: [
      "Centre-ville",
      "Sainte-Clotilde",
      "La Bretagne",
      "Le Chaudron",
      "La Source",
      "La Montagne",
      "Le Brûlé",
      "Saint-Bernard",
    ],
    pourquoi: [
      {
        title: "Maîtrise du PLU dense",
        desc: "Nous connaissons les particularités du PLU de Saint-Denis (zones U, prescriptions ABF en centre-ville, PPRI rivière des Pluies) pour sécuriser votre projet dès la phase de conception.",
      },
      {
        title: "Relations avec le service urbanisme",
        desc: "Nos dépôts sont systématiquement vérifiés en amont, ce qui réduit le nombre de demandes de pièces complémentaires et raccourcit le délai effectif d'obtention du permis.",
      },
      {
        title: "Expertise sols côtiers + hauts",
        desc: "Du littoral à La Montagne, nous adaptons les fondations à chaque profil géotechnique (alluvions, basalte, scories volcaniques).",
      },
    ],
    faq: [
      {
        q: "Quelles contraintes spécifiques pour construire en centre-ville de Saint-Denis ?",
        a: "Le centre historique est en partie couvert par un périmètre Architectes des Bâtiments de France (ABF). Toute construction, extension ou modification de façade en covisibilité d'un monument historique est soumise à un avis ABF, avec des prescriptions strictes sur les matériaux, les volumes, les ouvertures et les enseignes. Solmis Habitat anticipe ce volet dès la conception pour éviter les refus.",
      },
      {
        q: "Le PPRI de la rivière des Pluies impacte-t-il mon projet ?",
        a: "Si votre parcelle est située dans le périmètre du Plan de Prévention des Risques d'Inondation de la rivière des Pluies (ou d'autres cours d'eau locaux), le règlement impose des cotes plancher, des restrictions d'emprise et parfois des dispositifs constructifs spécifiques. Nous vérifions systématiquement le zonage avant de lancer la conception.",
      },
      {
        q: "Faut-il une étude de sol pour construire dans les hauts de Saint-Denis (La Montagne, Le Brûlé) ?",
        a: "Très fortement recommandé. Les terrains des hauts dionysiens présentent souvent des pentes, des scories volcaniques et des secteurs avec aléa mouvement de terrain. Une étude de sol G2 est généralement exigée par les assureurs et les banques, et elle évite les mauvaises surprises pendant les fondations.",
      },
    ],
  },

  "saint-pierre": {
    slug: "saint-pierre",
    name: "Saint-Pierre",
    region: "Sud",
    tagline: "Capitale du Sud",
    intro:
      "Construire à Saint-Pierre, deuxième ville de La Réunion et capitale économique du Sud, c'est s'inscrire dans une dynamique urbaine forte, avec un marché de la construction très actif depuis plusieurs années. Solmis Habitat accompagne particuliers et investisseurs sur toute la commune : du centre-ville et Terre-Sainte au littoral, jusqu'aux quartiers de Bois d'Olives, Ravine des Cabris, Ligne-Paradis et Mont Vert. Notre connaissance du PLU saint-pierrois, de l'environnement réglementaire local et des spécificités des sols du Sud nous permet de monter des dossiers de permis robustes, calibrés pour passer du premier coup en mairie.",
    geology:
      "Les sols de Saint-Pierre sont contrastés : plaines littorales sableuses ou basaltiques en bord de mer (Terre-Sainte, La Cafrine), ravines profondes traversant la commune, terrains argileux dans certains secteurs des mi-pentes (Ligne-Paradis, Ravine des Cabris, Bois d'Olives), et pentes plus marquées dans les hauts (Mont Vert, Bassin Plat). Une étude de sol G2 est vivement recommandée, notamment sur les terrains à risque de retrait-gonflement d'argile, fréquents dans certains quartiers.",
    plu:
      "Le PLU de Saint-Pierre fixe un zonage très détaillé avec des secteurs urbains denses (zones UA, UB) en centre-ville et littoral, des secteurs à dominante pavillonnaire (UC, UD) dans les quartiers résidentiels, et des zones agricoles et naturelles protégées dans les hauts. Les règles d'emprise au sol, de hauteur maximale et de recul varient fortement selon votre zonage. Plusieurs secteurs sont également couverts par des plans de prévention de risque (PPR inondation, mouvement de terrain).",
    mairie:
      "Mairie de Saint-Pierre — Service Urbanisme, place Hôtel de Ville, 97410 Saint-Pierre. Forte activité d'instruction toute l'année, dossiers à anticiper en période chargée (fin d'année et avant rentrée).",
    secteurs: [
      "Centre-ville",
      "Terre-Sainte",
      "Bois d'Olives",
      "Ravine des Cabris",
      "Ligne-Paradis",
      "Mont Vert",
      "Bassin Plat",
      "La Cafrine",
    ],
    pourquoi: [
      {
        title: "Connaissance fine du PLU saint-pierrois",
        desc: "Du zonage UA très contraint du centre-ville aux zones AU à urbaniser des extensions urbaines, nous maîtrisons les règles applicables à chaque secteur.",
      },
      {
        title: "Expertise sols argileux du Sud",
        desc: "Les terrains de Bois d'Olives, Ravine des Cabris et Ligne-Paradis comportent souvent de l'argile : nous dimensionnons les fondations en conséquence pour éviter les fissures.",
      },
      {
        title: "Dossiers calibrés pour le service urbanisme",
        desc: "Nous produisons des dossiers déjà conformes aux exigences de la mairie de Saint-Pierre, ce qui limite les demandes de pièces complémentaires.",
      },
    ],
    faq: [
      {
        q: "Mon terrain est en zone argileuse à Bois d'Olives ou Ligne-Paradis : que faire ?",
        a: "Les sols argileux sont soumis au phénomène de retrait-gonflement (gonflement sous l'eau, rétraction en saison sèche), qui peut provoquer des fissures dans les fondations classiques. L'étude de sol G2 identifie précisément la nature de l'argile et permet de dimensionner des fondations adaptées (semelles renforcées, longrines, voire pieux). C'est aujourd'hui une exigence quasi systématique des assureurs sur ces secteurs.",
      },
      {
        q: "Combien de temps pour obtenir un permis à Saint-Pierre ?",
        a: "Le délai légal d'instruction est de 2 mois pour une maison individuelle et de 3 mois pour les autres projets, à compter du dépôt du dossier complet en mairie. Le service urbanisme de Saint-Pierre instruit dans les délais légaux pour les dossiers bien préparés ; les demandes de pièces complémentaires peuvent allonger ce délai de plusieurs semaines.",
      },
      {
        q: "Puis-je construire un logement locatif à Terre-Sainte ou en bord de littoral ?",
        a: "Oui, sous réserve du respect du PLU, des servitudes littorales éventuelles et des règles d'urbanisme propres au zonage. Solmis Habitat vérifie gratuitement la faisabilité de votre projet locatif sur Saint-Pierre avant tout engagement.",
      },
    ],
  },

  "le-tampon": {
    slug: "le-tampon",
    name: "Le Tampon",
    region: "Sud / Hauts",
    tagline: "Les hauts du Sud",
    intro:
      "Construire au Tampon, c'est composer avec l'altitude (de 600 à plus de 1 600 m), des pentes parfois marquées, et des terrains volcaniques récents issus des coulées du Piton de la Fournaise et de la Plaine des Cafres. Solmis Habitat accompagne les projets de construction sur l'ensemble de la commune : du 14ème au 23ème kilomètre, Trois-Mares, Bras-Creux, Bérive, Pont d'Yves, jusqu'à la Plaine des Cafres et Bourg-Murat. Notre expertise des fondations adaptées aux scories volcaniques, ainsi que notre maîtrise du PLU du Tampon et de ses prescriptions de hauteur en altitude, permettent de mener à terme des projets parfois jugés complexes ailleurs.",
    geology:
      "Le sol tamponnais est emblématique de La Réunion volcanique : scories noires et rouges, basaltes massifs alternés avec couches de cendres, et coulées de lave plus ou moins anciennes. La portance varie fortement d'un secteur à l'autre — un terrain peut être très porteur en surface et présenter une cavité ou une lave-tube quelques mètres plus bas. L'étude de sol G2, voire G2 PRO + G3 sur projets ambitieux, est indispensable. Les zones de pente nécessitent aussi des solutions de soutènement et un drainage soigné.",
    plu:
      "Le PLU du Tampon prend en compte les fortes contraintes de relief et la sensibilité paysagère des hauts. Il fixe des hauteurs maximales souvent inférieures aux communes du littoral (généralement R+1 voire R+combles selon les secteurs), des règles de couleur de toiture et d'implantation pour préserver le caractère rural des hauts, et impose un recul strict par rapport aux ravines. Certaines zones sont couvertes par un Plan de Prévention des Risques mouvement de terrain.",
    mairie:
      "Mairie du Tampon — Service Urbanisme, 423 rue Hubert-Delisle, 97430 Le Tampon. Forte sensibilité paysagère : prévoir l'insertion architecturale dès la conception (couleurs, volumétries, toitures).",
    secteurs: [
      "Centre-ville (14ème km)",
      "Trois-Mares",
      "Bras-Creux",
      "Bérive",
      "Pont d'Yves",
      "Plaine des Cafres",
      "Bourg-Murat",
      "23ème km",
    ],
    pourquoi: [
      {
        title: "Fondations adaptées aux scories",
        desc: "Les terrains volcaniques du Tampon réservent des surprises : cavités, hétérogénéités, lave-tubes. Nous dimensionnons les fondations en conséquence.",
      },
      {
        title: "Maîtrise des contraintes d'altitude",
        desc: "Pente, vent en altitude, gel ponctuel l'hiver dans les hauts : nous intégrons ces données dès la conception du projet.",
      },
      {
        title: "Insertion paysagère soignée",
        desc: "Pour passer le filtre du service urbanisme et préserver le charme des hauts, nous travaillons les volumes, les couleurs de toiture et l'orientation.",
      },
    ],
    faq: [
      {
        q: "Mon terrain est sur une coulée de lave : puis-je construire ?",
        a: "Oui, dans la grande majorité des cas. Les coulées anciennes et stabilisées sont parfaitement constructibles avec des fondations adaptées. L'étude de sol G2 permet d'identifier la nature exacte de la coulée (basalte massif, scorie, cendres) et la présence éventuelle de cavités ou de lave-tubes. C'est notre partenaire Innocean qui réalise ces missions, avec une grande expérience des sols volcaniques du Tampon.",
      },
      {
        q: "Quels types de toitures sont acceptés au Tampon ?",
        a: "Le PLU du Tampon impose généralement des prescriptions sur les couleurs et la pente des toitures pour préserver le caractère paysager des hauts. Les tons sombres (tuiles brunes, bacs acier teinte tuile, etc.) sont privilégiés ; les couleurs claires et brillantes sont souvent proscrites. Nous intégrons ces règles dès le permis pour éviter un refus pour motif esthétique.",
      },
      {
        q: "Faut-il une étude de sol en altitude (Plaine des Cafres, 23ème km) ?",
        a: "Oui, absolument. À haute altitude, la portance peut être bonne mais hétérogène, et le drainage prend une importance critique en raison des fortes pluies. Une G2 systématique évite les fissurations et les infiltrations dans la dalle.",
      },
    ],
  },

  "saint-paul": {
    slug: "saint-paul",
    name: "Saint-Paul",
    region: "Ouest",
    tagline: "La plus vaste commune de l'île",
    intro:
      "Saint-Paul couvre un territoire immense, du littoral ensoleillé de Boucan Canot et Saint-Gilles aux hauts boisés du Maïdo, en passant par Plateau Caillou, Le Guillaume, Bois-de-Nèfles et La Saline-les-Hauts. Cette diversité géographique implique des règles de construction très contrastées selon votre parcelle. Solmis Habitat accompagne tous les types de projet sur la commune : résidences secondaires en littoral, villas avec piscine, extensions, surélévations ou constructions neuves dans les mi-pentes et les hauts. Notre connaissance du PLU saint-paulois et de ses zonages multiples, alliée à notre maîtrise des contraintes du vent côtier et des sols volcaniques, garantit la solidité de votre dossier.",
    geology:
      "L'ouest réunionnais présente plusieurs grandes familles de sols : substrats coralliens et alluvions sableuses en bord de mer (Saint-Gilles, La Saline-les-Bains, Boucan Canot), basaltes massifs alternés avec scories sur les pentes (Plateau Caillou, Le Guillaume, Bernica), et coulées volcaniques plus récentes en altitude (Bois-de-Nèfles, hauts du Maïdo). La proximité de l'océan impose aussi de tenir compte de l'agressivité saline pour les structures béton et les éléments métalliques.",
    plu:
      "Le PLU de Saint-Paul est l'un des plus complexes de l'île compte tenu de la superficie communale. Il distingue des zones touristiques en bord de mer (avec contraintes spécifiques), des zones urbaines pavillonnaires sur les pentes, des zones agricoles protégées, et des zones naturelles inconstructibles sur les hauts (parc national). Plusieurs secteurs sont également couverts par des PPR (mouvement de terrain, feu de forêt dans les hauts).",
    mairie:
      "Mairie de Saint-Paul — Service Urbanisme, 28 rue Mahatma Gandhi, 97460 Saint-Paul. Service très chargé en raison de la dynamique de construction de la côte Ouest : un dossier propre dès le dépôt fait gagner plusieurs semaines.",
    secteurs: [
      "Saint-Gilles-les-Bains",
      "La Saline-les-Bains",
      "Boucan Canot",
      "Plateau Caillou",
      "Le Guillaume",
      "Bois-de-Nèfles",
      "Bernica",
      "L'Éperon",
    ],
    pourquoi: [
      {
        title: "Maîtrise des projets balnéaires",
        desc: "Vent salin, vues à valoriser, intégration paysagère côtière : nous concevons des projets durables et conformes aux règles littorales.",
      },
      {
        title: "Expertise zones touristiques",
        desc: "Saint-Gilles et La Saline sont soumis à des contraintes spécifiques (servitudes touristiques, vues, hauteurs). Nous les anticipons dès la conception.",
      },
      {
        title: "Connaissance des hauts saint-paulois",
        desc: "Pentes, basalte, secteurs avec aléa mouvement de terrain dans les hauts : nous adaptons fondations et implantation.",
      },
    ],
    faq: [
      {
        q: "Quelles contraintes spécifiques pour construire à Saint-Gilles ou Boucan Canot ?",
        a: "Le littoral ouest est soumis à des règles particulières : recul par rapport au domaine public maritime, prescriptions de hauteur pour préserver les vues, servitudes touristiques dans certains périmètres. Il faut également tenir compte de l'agressivité saline qui impose des aciers traités et des bétons adaptés. Nous intégrons systématiquement ces points dans la conception.",
      },
      {
        q: "Puis-je construire dans les hauts du Maïdo ou de Bois-de-Nèfles ?",
        a: "Cela dépend du zonage PLU de votre parcelle. Une partie des hauts est en zone naturelle inconstructible (parc national, espaces boisés classés). Une autre partie est constructible mais avec des règles strictes (hauteur, couleur, recul, prescriptions paysagères). Nous vérifions gratuitement la faisabilité avant toute conception.",
      },
      {
        q: "Combien de temps pour un permis à Saint-Paul ?",
        a: "Saint-Paul est la commune qui enregistre le plus de dépôts de permis sur l'ouest. Le délai légal est respecté pour les dossiers propres, mais en période chargée la marge est faible. Un dossier complet et conforme dès le dépôt évite des semaines de retard.",
      },
    ],
  },

  "sainte-marie": {
    slug: "sainte-marie",
    name: "Sainte-Marie",
    region: "Nord-Est",
    tagline: "Porte d'entrée de l'île",
    intro:
      "Sainte-Marie, commune dynamique du nord-est de La Réunion, accueille l'aéroport Roland Garros et connaît une forte croissance résidentielle depuis dix ans, notamment sur les secteurs de Bois Rouge, Beaumont, Duparc et La Confiance. Solmis Habitat accompagne les projets de construction et d'extension dans toute la commune, du littoral aux hauts (La Convenance, Rivière des Pluies, Beaufonds). Notre maîtrise du PLU de Sainte-Marie, des servitudes liées à l'aéroport et des contraintes hydrauliques de la rivière Sainte-Marie permet de sécuriser chaque dossier de permis dès la phase de conception.",
    geology:
      "Le territoire de Sainte-Marie est marqué par la présence de plusieurs cours d'eau et ravines (rivière Sainte-Marie, ravine Charpentier), avec des alluvions et limons en bord d'eau. Les terrains du littoral sont souvent sableux ou basaltiques selon les secteurs, et les hauts mêlent basaltes, scories et zones argileuses. Le PPRI de la rivière Sainte-Marie impose des contraintes fortes sur les parcelles concernées (cotes plancher, restrictions d'emprise).",
    plu:
      "Le PLU de Sainte-Marie classe la majeure partie du territoire urbanisé en zones U avec sous-secteurs distincts selon les quartiers (UA centre-ville, UB pavillonnaire dense, UC pavillonnaire diffus). Plusieurs secteurs sont impactés par des servitudes aéronautiques (aéroport Roland Garros) limitant les hauteurs de construction. Le PPRI rivière Sainte-Marie est opposable et conditionne la constructibilité de certaines parcelles.",
    mairie:
      "Mairie de Sainte-Marie — Service Urbanisme, 110 rue de la Convenance, 97438 Sainte-Marie. Service rigoureux sur la conformité PLU et les servitudes aéronautiques.",
    secteurs: [
      "Centre-ville",
      "Bois Rouge",
      "Beaumont",
      "Duparc",
      "La Confiance",
      "Beaufonds",
      "Rivière des Pluies",
      "La Convenance",
    ],
    pourquoi: [
      {
        title: "Maîtrise des servitudes aéroportuaires",
        desc: "Sainte-Marie est concernée par des limitations de hauteur strictes liées à l'aéroport Roland Garros. Nous les intégrons dès l'esquisse pour éviter tout refus.",
      },
      {
        title: "Expertise PPRI rivière Sainte-Marie",
        desc: "Nous vérifions systématiquement si votre parcelle est concernée et adaptons les cotes plancher et l'emprise du projet en conséquence.",
      },
      {
        title: "Réactivité Nord-Est",
        desc: "Nous intervenons rapidement dans le secteur Bois Rouge / Duparc / Beaumont, où la dynamique de construction est forte.",
      },
    ],
    faq: [
      {
        q: "L'aéroport limite-t-il vraiment la hauteur de ma construction ?",
        a: "Oui, les servitudes aéronautiques imposent des cotes maximales de hauteur sur de nombreux secteurs de Sainte-Marie, en fonction de la distance à la piste et des cônes d'envol. Sur certaines parcelles cela limite à un R+1 voire au RDC seul. Nous vérifions systématiquement la servitude applicable avant toute conception.",
      },
      {
        q: "Mon terrain est près de la rivière Sainte-Marie : suis-je en zone inondable ?",
        a: "Le PPRI rivière Sainte-Marie identifie des zones rouges (inconstructibles), bleues (constructibles avec prescriptions) et résiduelles autour du cours d'eau. Nous consultons la cartographie officielle pour votre parcelle exacte et adaptons le projet (cotes plancher relevées, emprise réduite, etc.).",
      },
      {
        q: "Sainte-Marie est-elle bien instruite côté mairie ?",
        a: "Le service urbanisme de Sainte-Marie est rigoureux sur la conformité PLU et les servitudes. Un dossier propre passe sans difficulté ; un dossier approximatif déclenche systématiquement des demandes de pièces complémentaires. Nous calibrons nos dépôts en conséquence.",
      },
    ],
  },

  "saint-benoit": {
    slug: "saint-benoit",
    name: "Saint-Benoît",
    region: "Est",
    tagline: "Capitale de l'Est",
    intro:
      "Construire à Saint-Benoît, capitale de la région Est et commune emblématique de la côte au vent, demande de bien intégrer les spécificités hydrauliques et météorologiques de l'est de l'île : pluviométrie élevée, ravines puissantes, sols souvent saturés en eau, ravinements actifs en saison cyclonique. Solmis Habitat accompagne les projets de construction et d'extension dans toute la commune : Bras-Madeleine, Bras-Canot, Beaufonds, Saint-Benoît centre, Bourbier, Sainte-Anne, jusqu'aux hauts (Cambourg, Plaine des Palmistes pour les confins). Notre dimensionnement assainissement adapté à la pluviométrie de l'est et notre maîtrise du PLU saint-benoîtois garantissent des projets durables et conformes.",
    geology:
      "Saint-Benoît est traversée par plusieurs cours d'eau majeurs (rivière des Marsouins, rivière de l'Est, ravines de Bras-Panon limitrophes). Les sols comportent une part importante d'alluvions et de scories des fleuves, avec un drainage parfois insuffisant sur les zones plates en aval. Les terrains des hauts présentent plus de basaltes massifs et de coulées historiques. La pluviométrie record de l'est (jusqu'à 4 m/an dans certains secteurs) impose un soin particulier au drainage, à l'orientation des bâtiments et à l'étanchéité.",
    plu:
      "Le PLU de Saint-Benoît est très sensible aux risques naturels : plusieurs secteurs sont couverts par des PPR inondation (rivière des Marsouins notamment), des PPR mouvement de terrain (ravinements actifs) et des prescriptions liées à l'aléa cyclonique. Les zones U pavillonnaires sont concentrées autour du centre-ville et le long des axes principaux ; les hauts et l'arrière-pays sont majoritairement en zones A et N.",
    mairie:
      "Mairie de Saint-Benoît — Service Urbanisme, place Hippolyte Foucque, 97470 Saint-Benoît. Service attentif aux risques naturels et à la gestion des eaux pluviales.",
    secteurs: [
      "Saint-Benoît centre",
      "Bras-Madeleine",
      "Bras-Canot",
      "Beaufonds",
      "Bourbier",
      "Sainte-Anne",
      "Cambourg",
      "Rivière des Marsouins",
    ],
    pourquoi: [
      {
        title: "Dimensionnement pluvial adapté à l'Est",
        desc: "Avec une pluviométrie record, l'évacuation des eaux pluviales doit être pensée bien au-delà des normes : nous dimensionnons des solutions robustes (gouttières larges, drains, bassins de rétention).",
      },
      {
        title: "Connaissance des PPR locaux",
        desc: "Inondation, ravinement, cyclonique : nous croisons les PPR applicables à votre parcelle et adaptons le projet (cotes plancher, ancrage cyclonique).",
      },
      {
        title: "Réseau local de partenaires",
        desc: "Nos partenaires terrassement, fondations et étanchéité maîtrisent les contraintes spécifiques de l'est et du climat tropical humide.",
      },
    ],
    faq: [
      {
        q: "Comment gérer la pluviométrie record de Saint-Benoît dans la conception ?",
        a: "Le projet doit prévoir une évacuation des eaux pluviales largement surdimensionnée par rapport au standard métropolitain : gouttières larges (parfois 200 mm et plus), drains périphériques, pente naturelle de la parcelle exploitée, voire bassin de rétention sur les grandes toitures. L'orientation du bâti par rapport aux vents dominants d'est-sud-est est également stratégique.",
      },
      {
        q: "Mon terrain est dans le PPRI rivière des Marsouins : quelles conséquences ?",
        a: "Le PPRI fixe des zones rouges (inconstructibles), des zones bleues (constructibles avec prescriptions : cote plancher, emprise au sol limitée, etc.) et des zones résiduelles. La cartographie officielle permet de connaître exactement le zonage de votre parcelle. Nous l'intégrons dès la conception pour ne pas devoir tout reprendre après dépôt.",
      },
      {
        q: "Faut-il une étude de sol obligatoire à Saint-Benoît ?",
        a: "Très fortement recommandé. Les sols saturés, les alluvions et les variations de portance en bord de rivière justifient une G2 quasi systématique. C'est aussi une exigence courante des assureurs et des banques sur cette zone.",
      },
    ],
  },
};

export const COMMUNE_SLUGS = Object.keys(COMMUNES);
